import React from "react";
import AttendeeItem from "../components/AttendeeItem";
import { EventInfo } from "../../shared/components";
import Receipt from "../components/Receipt";
import { Map } from "../../shared/components";

export default class AttendeesForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCustomField = this.handleCustomField.bind(this);
    this.handleTextField = this.handleTextField.bind(this);
    this.handleFBShare = this.handleFBShare.bind(this);

    this.state = {
      attendeeCustomFields: this.intializeAttendeeCustomFields(props.attendees),
      attendees: this.initializeAttendees(props.attendees),
    };
  }

  initializeAttendees(attendees) {
    return attendees.reduce((obj, attendee) => {
      obj[attendee.ticket_id] = attendee;
      return obj;
    }, {});
  }

  componentWillReceiveProps(nextProps) {
    console.log("componentWillReceiveProps", nextProps);
    this.state = {
      attendeeCustomFields: this.intializeAttendeeCustomFields(nextProps.attendees),
      attendees: this.initializeAttendees(nextProps.attendees),
    };
  }

  intializeAttendeeCustomFields(attendees) {
    const customFields = attendees.reduce((obj, attendee) => {
      obj[attendee.ticket_id] = attendee.custom_fields.reduce((customFieldObj, field) => {
        customFieldObj[field.label] = null;
        return customFieldObj;
      }, {});

      return obj;
    }, {});

    Object.keys(customFields).forEach((keyName) => {
      attendees.forEach((attendee) => {
        if (attendee.ticket_id == keyName) {
          customFields[keyName] = attendee.custom_fields_hash;
        }
      });
    });

    return customFields;
  }

  handleFBShare(e) {
    const { shareLink } = this.props;

    e.preventDefault();
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${shareLink}`,
      "pop",
      "width=600, height=400, scrollbars=no",
    );
  }

  handleCustomField(ticketId, value, label) {
    const customFields = this.state.attendeeCustomFields;

    customFields[ticketId] = Object.assign({}, customFields[ticketId], {
      [label]: value,
    });

    this.setState({
      attendeeCustomFields: customFields,
    });
  }

  handleTextField(ticketId, value, attr) {
    const { attendees } = this.state;

    attendees[ticketId] = Object.assign({}, attendees[ticketId], {
      [attr]: value,
    });

    this.setState({
      attendees,
    });
  }

  renderAttendees() {
    const { attendees } = this.state;

    let initallySetToEdit = 0;

    const attendeesComponents = Object.keys(attendees).map((key, index) => {
      const attendee = attendees[key];

      let editing;

      if (initallySetToEdit < 2) {
        editing = true;
        initallySetToEdit++;
      }

      return (
        <AttendeeItem
          key={index}
          number={index}
          attendee={attendee}
          editing={editing}
          changeCustomField={this.handleCustomField}
          changeTextField={this.handleTextField}
          customFieldValues={this.state.attendeeCustomFields[attendee.ticket_id]}
          customFields={attendee.custom_fields}
          editable={this.props.editable}
        />
      );
    });
    return (
      <div className="flex-it flex-wrap space-between align-start">
        {attendeesComponents}
      </div>
    );
  }

  handleSubmit = async (event) => {
    // NOTE: does not appear to be used
    // this.setState({loading: true})

    // NOTE: for now redirect is handled in update.js (whether form is editable or not)
    // const { redirectLink } = this.props
    $("#new_attendees_form").submit();
  };

  render() {
    const { form_authenticity_token, event } = this.props;
    const { attendees } = this.state;

    const attendeesArray = Object.keys(attendees).map((key) => attendees[key]);

    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <form
              data-remote="true"
              action={`/attendees/${this.props.id}`}
              acceptCharset="UTF-8"
              className={
                this.props.editable ? "new_attendees_form" : "new_attendees_form disabled"
              }
              id="new_attendees_form"
              method="put"
              noValidate="novalidate">
              <div className="hidden">
                <input
                  data-testid="t-attende-registr--Attende-utf8"
                  name="utf8"
                  type="hidden"
                  value="✓"
                />
                <input
                  data-testid="t-attende-registr--Attende-_method"
                  name="_method"
                  type="hidden"
                  value="put"
                />
                <input
                  data-testid="t-attende-registr--Attende-authenticity_token"
                  name="authenticity_token"
                  type="hidden"
                  value={form_authenticity_token}
                />
              </div>
              <div className="event-modal">
                <div className="event-modal-background">
                  <div className="event-modal-top">
                    <h2 className="event-modal-header">THANK YOU FOR REGISTERING</h2>
                    <span className="event-modal-directions">
                      You have successfully registered for {event.name}. The information
                      below represents your registration event confirmation, and the
                      ability to edit details regarding you and your guest's registration
                      information. Please take the time to read through the information
                      and complete your guest's information below (if applicable). Thank
                      you.
                    </span>
                  </div>
                  <div className="event-modal-body">
                    <div className="clearfix">
                      <div className="col-xs-12 col-sm-6">
                        <h2 className="receipt-header primary-color-text">
                          Receipt Confirmation
                        </h2>
                        <div className="m-md-a">
                          <h3 className="receipt-title">Confirmation Number</h3>
                          <span>{attendeesArray[0].donation_id}</span>
                        </div>

                        <Receipt attendees={attendeesArray} />
                      </div>
                      <div className="col-xs-12 col-sm-6">
                        <div className="m-md-t m-md-b">
                          <EventInfo event={event} />
                        </div>
                        <div className="event-border-top">
                          <Map address={event.address} />
                        </div>
                      </div>
                    </div>
                    <div className="event-modal-form">
                      <div className="row">
                        <div className="col-xs-12 col-sm-6">
                          <h2 className="receipt-header primary-color-text">
                            {this.props.editable
                              ? "Please Update Your Tickets"
                              : "Ticket Information"}
                          </h2>
                        </div>
                      </div>
                      <fieldset>{this.renderAttendees()}</fieldset>
                      <h3 className="text-center">Share</h3>
                      <div className="p-sm-t text-center">
                        <i
                          className="fa fa-3x fa-brands fa-square-facebook fb-font-color pointer"
                          onClick={this.handleFBShare}></i>
                      </div>
                    </div>
                  </div>
                  <div className="event-modal-bottom">
                    <button
                      data-testid="t-attende-registr--Attende-button"
                      title={this.props.editable ? "register" : "OK"}
                      type="button"
                      className="register-modal-btn"
                      onClick={this.handleSubmit.bind(this)}>
                      {this.props.editable ? "Submit" : "OK"}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
